var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-options"},[_c('social-login'),_c('email-login-button',{on:{"click":_vm.goToLoginWithEmail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }